import { useCallback, useState } from 'react';
import { TextInput } from '@cbhq/cds-web/controls';
import { Icon } from '@cbhq/cds-web/icons';
import { HStack } from '@cbhq/cds-web/layout';
import { NavigationTitle } from '@cbhq/cds-web/navigation/NavigationTitle';
import { Pressable } from '@cbhq/cds-web/system';

type InlineEditableTitleProps = {
  value?: string;
};

// TODO: complete implementation of editing once design is finalized
// eslint-disable-next-line import/no-unused-modules
export function InlineEditableTitle({ value }: InlineEditableTitleProps) {
  const [editedValue, setEditedValue] = useState(value);
  const [isEditing, setIsEditing] = useState(false);
  const [showIcon, setShowIcon] = useState(false);

  const handleOnChange = useCallback((e) => {
    setEditedValue(e.target.value);
  }, []);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      setIsEditing(false);
    }
  }, []);

  return isEditing ? (
    <HStack width="100%" height="100%" alignItems="center">
      <TextInput
        value={editedValue || value}
        bordered={false}
        onChange={handleOnChange}
        onPress={() => setIsEditing(false)}
        autoFocus
        onBlur={() => setIsEditing(false)}
        onKeyDown={handleKeyDown}
        variant="foreground"
        height={46}
      />
    </HStack>
  ) : (
    <Pressable
      background="transparent"
      onPress={() => setIsEditing(true)}
      noScaleOnPress
      onMouseEnter={() => setShowIcon(true)}
      onMouseLeave={() => setShowIcon(false)}
    >
      <HStack width="100%" justifyContent="flex-start" alignItems="center" gap={1}>
        {/* @ts-expect-error -- error says this component requires >1 child 🤷  */}
        <NavigationTitle align="start" overflow="break" numberOfLines={2}>
          {value}
        </NavigationTitle>
        {showIcon && <Icon color="foreground" size="s" name="pencil" />}
      </HStack>
    </Pressable>
  );
}

// temporary use while EditableTitle is WIP
export function StaticTitle({ value }: InlineEditableTitleProps) {
  return (
    <HStack width="100%" justifyContent="flex-start" alignItems="center" gap={1}>
      {/* @ts-expect-error -- error says this component requires >1 child 🤷  */}
      <NavigationTitle align="start" overflow="break" numberOfLines={2}>
        {value}
      </NavigationTitle>
    </HStack>
  );
}
